<p-toast></p-toast>

<!-- Skeleton loading state -->
<div class="preview-container" *ngIf="loading">
  <!-- Header skeleton -->
  <div class="preview-header">
    <div class="flex justify-content-between align-items-center">
      <div class="header-title">
        <i class="pi pi-eye text-3xl"></i>
        <h1 class="ml-3">Cotización</h1>
      </div>
      <div class="header-actions">
        <p-skeleton width="80px" height="40px" class="mr-2"></p-skeleton>
        <p-skeleton width="80px" height="40px" class="mr-2"></p-skeleton>
        <!-- <p-skeleton width="140px" height="40px" class="mr-2"></p-skeleton> -->
        <p-skeleton width="120px" height="40px"></p-skeleton>
      </div>
    </div>
  </div>

  <!-- Cards grid skeleton -->
  <div class="preview-content">
    <div class="cards-grid">
      <!-- Client info card skeleton -->
      <div class="info-card">
        <div class="card-header">
          <i class="pi pi-user"></i>
          <h3>Información del Cliente</h3>
          <div class="header-tags">
            <p-skeleton width="80px" height="24px"></p-skeleton>
          </div>
        </div>
        <div class="card-content">
          <!-- Client Basic Info Skeleton -->
          <div class="client-basic-info">
            <div class="client-avatar">
              <p-skeleton shape="circle" size="60px"></p-skeleton>
            </div>
            <div class="client-details">
              <p-skeleton width="180px" height="24px" class="mb-3"></p-skeleton>
              <div class="client-meta">
                <div class="meta-item">
                  <i class="pi pi-envelope text-gray-500"></i>
                  <p-skeleton width="200px" height="18px"></p-skeleton>
                </div>
                <div class="meta-item">
                  <i class="pi pi-phone text-gray-500"></i>
                  <p-skeleton width="150px" height="18px"></p-skeleton>
                </div>
                <div class="meta-item">
                  <i class="pi pi-id-card text-gray-500"></i>
                  <p-skeleton width="120px" height="18px"></p-skeleton>
                </div>
              </div>
            </div>
          </div>

          <!-- Quote Timeline Skeleton -->
          <div class="quote-timeline">
            <div class="timeline-header">
              <i class="pi pi-clock text-blue-600"></i>
              <p-skeleton width="140px" height="18px"></p-skeleton>
            </div>
            <div class="timeline-items">
              <div class="timeline-item created">
                <div class="timeline-marker">
                  <p-skeleton shape="circle" size="32px"></p-skeleton>
                </div>
                <div class="timeline-content">
                  <p-skeleton width="80px" height="16px" class="mb-1"></p-skeleton>
                  <p-skeleton width="160px" height="14px"></p-skeleton>
                </div>
              </div>
              <div class="timeline-item updated">
                <div class="timeline-marker">
                  <p-skeleton shape="circle" size="32px"></p-skeleton>
                </div>
                <div class="timeline-content">
                  <p-skeleton width="90px" height="16px" class="mb-1"></p-skeleton>
                  <p-skeleton width="170px" height="14px"></p-skeleton>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Assets info card skeleton -->
      <div class="info-card assets-enhanced-card">
        <div class="card-header">
          <i class="pi pi-box"></i>
          <h3>Información de Activos</h3>
          <div class="header-tags">
            <p-skeleton width="80px" height="24px" class="mr-2"></p-skeleton>
            <p-skeleton width="90px" height="24px"></p-skeleton>
          </div>
        </div>
        <div class="card-content">
          <!-- Assets Summary Bar Skeleton -->
          <div class="assets-summary-bar-horizontal">
            <div class="summary-stat">
              <i class="pi pi-tags text-blue-600"></i>
              <div class="stat-content">
                <p-skeleton width="70px" height="12px" class="mb-1"></p-skeleton>
                <p-skeleton width="120px" height="16px"></p-skeleton>
              </div>
            </div>
            <div class="summary-stat">
              <i class="pi pi-calendar text-green-600"></i>
              <div class="stat-content">
                <p-skeleton width="80px" height="12px" class="mb-1"></p-skeleton>
                <p-skeleton width="140px" height="16px"></p-skeleton>
              </div>
            </div>
          </div>

          <!-- Assets and Financial Layout Skeleton -->
          <div class="assets-financial-container">
            <!-- Left Column: Assets List Skeleton -->
            <div class="assets-list-section">
              <div class="section-header">
                <div class="section-title">
                  <i class="pi pi-list text-blue-600"></i>
                  <p-skeleton width="130px" height="18px"></p-skeleton>
                </div>
              </div>

              <!-- Asset Cards Skeleton -->
              <div class="assets-list-container">
                <div class="asset-card-improved" *ngFor="let item of [1, 2, 3]">
                  <!-- Asset Header Skeleton -->
                  <div class="asset-header-section">
                    <div class="asset-identity">
                      <p-skeleton shape="circle" size="22px"></p-skeleton>
                      <div class="asset-name-section">
                        <p-skeleton width="180px" height="18px" class="mb-2"></p-skeleton>
                        <div class="asset-status-badges">
                          <p-skeleton width="80px" height="20px" class="mr-2"></p-skeleton>
                          <p-skeleton width="70px" height="20px"></p-skeleton>
                        </div>
                      </div>
                    </div>
                    <div class="asset-value-section">
                      <p-skeleton width="100px" height="20px"></p-skeleton>
                    </div>
                  </div>

                  <!-- Asset Details Skeleton -->
                  <div class="asset-details-section">
                    <div class="details-grid">
                      <p-skeleton width="60px" height="24px" class="mr-2"></p-skeleton>
                      <p-skeleton width="70px" height="24px" class="mr-2"></p-skeleton>
                      <p-skeleton width="65px" height="24px" class="mr-2"></p-skeleton>
                      <p-skeleton width="55px" height="24px"></p-skeleton>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Right Column: Financial Summary Skeleton -->
            <div class="financial-summary-section">
              <div class="section-header">
                <div class="section-title">
                  <i class="pi pi-calculator text-green-600"></i>
                  <p-skeleton width="140px" height="18px"></p-skeleton>
                </div>
              </div>

              <div class="financial-summary-card">
                <div class="financial-breakdown">
                  <div class="breakdown-row">
                    <p-skeleton width="110px" height="14px"></p-skeleton>
                    <p-skeleton width="100px" height="16px"></p-skeleton>
                  </div>
                  <div class="breakdown-row">
                    <p-skeleton width="70px" height="14px"></p-skeleton>
                    <p-skeleton width="90px" height="16px"></p-skeleton>
                  </div>
                  <div class="breakdown-separator"></div>
                  <div class="breakdown-row">
                    <p-skeleton width="120px" height="14px"></p-skeleton>
                    <p-skeleton width="120px" height="20px"></p-skeleton>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Financial config card skeleton -->
    <div class="info-card wide-card">
      <div class="card-header">
        <i class="pi pi-calculator"></i>
        <h3>Configuración Financiera</h3>
      </div>
      <div class="card-content">
        <div class="financial-grid">
          <div class="financial-item" *ngFor="let item of [1, 2, 3, 4, 5, 6]">
            <p-skeleton width="140px" height="14px" class="mb-2"></p-skeleton>
            <p-skeleton width="80px" height="20px"></p-skeleton>
          </div>
        </div>
      </div>
    </div>

    <!-- Terms and accessories skeletons -->
    <div class="cards-grid">
      <div class="info-card">
        <div class="card-header">
          <i class="pi pi-list"></i>
          <h3>Términos Configurados</h3>
          <p-skeleton width="80px" height="24px"></p-skeleton>
        </div>
        <div class="card-content">
          <div class="terms-table">
            <div class="table-header">
              <span class="header-cell">Término (meses)</span>
              <span class="header-cell">Valor Residual (%)</span>
            </div>
            <div class="table-body">
              <div class="table-row" *ngFor="let row of [1, 2, 3, 4, 5]">
                <p-skeleton width="60px" height="18px"></p-skeleton>
                <p-skeleton width="70px" height="18px"></p-skeleton>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="info-card">
        <div class="card-header">
          <i class="pi pi-plus-circle"></i>
          <h3>Accesorios</h3>
          <p-skeleton width="80px" height="24px"></p-skeleton>
        </div>
        <div class="card-content">
          <div class="accessories-section">
            <p-skeleton width="140px" height="18px" class="mb-3"></p-skeleton>
            <div class="accessories-list">
              <div class="accessory-item" *ngFor="let row of [1, 2, 3]">
                <div class="accessory-header">
                  <p-skeleton width="150px" height="18px"></p-skeleton>
                  <p-skeleton width="80px" height="24px"></p-skeleton>
                </div>
                <div class="accessory-details">
                  <p-skeleton width="100px" height="16px" class="mr-3"></p-skeleton>
                  <p-skeleton width="80px" height="16px"></p-skeleton>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Main content -->
<div class="preview-container" *ngIf="quoteParameters && !loading">
  <!-- Header with actions -->
  <div class="preview-header">
    <div class="flex justify-content-between align-items-center">
      <div class="header-title">
        <i class="pi pi-eye text-3xl text-primary"></i>
        <h1 class="ml-3">Cotización</h1>
      </div>
      <div class="header-actions">
        <button pButton type="button" label="Volver" icon="pi pi-arrow-left" class="p-button-outlined mr-2" (click)="goBack()"></button>
        <button pButton type="button" label="Editar" icon="pi pi-pencil" class="p-button-outlined mr-2" (click)="editParameters()"></button>
        <!-- <button 
                    pButton 
                    type="button" 
                    label="Tabla de Amortización" 
                    icon="pi pi-calculator" 
                    class="p-button-success mr-2"
                    [loading]="loading"
                    (click)="calculateQuote()">
                </button> -->
        <button
          pButton
          type="button"
          icon="fa-regular fa-file-pdf"
          class="pdf-button p-button-outlined"
          [loading]="downloadingPDF"
          [disabled]="downloadingPDF"
          (click)="downloadParametersPDF()"
          pTooltip="Descargar PDF"
          tooltipPosition="top"
        ></button>
      </div>
    </div>
  </div>

  <!-- Content cards -->
  <div class="preview-content">
    <!-- First row: General, Client, Assets info -->
    <div class="cards-grid">
      <!-- Client Information Card -->
      <div class="info-card">
        <div class="card-header">
          <i class="pi pi-user text-indigo-600"></i>
          <h3>Información del Cliente</h3>
          <div class="header-tags">
            <p-tag *ngIf="hasDefinitiveClient()" value="Definitivo" severity="success" class="client-tag"> </p-tag>
            <p-tag *ngIf="!hasDefinitiveClient()" value="Provisional" severity="warning" class="client-tag"> </p-tag>
          </div>
        </div>
        <div class="card-content">
          <!-- Client Basic Info -->
          <div class="client-basic-info">
            <div class="client-avatar">
              <i class="pi pi-user text-4xl text-indigo-500"></i>
            </div>
            <div class="client-details">
              <h4 class="client-name">{{ getClientName() }}</h4>
              <div class="client-meta" *ngIf="hasDefinitiveClient() && quoteParameters.client">
                <div class="meta-item" *ngIf="quoteParameters.client.email">
                  <i class="pi pi-envelope text-gray-500"></i>
                  <span class="meta-value">{{ quoteParameters.client.email }}</span>
                </div>
                <div class="meta-item" *ngIf="quoteParameters.client.phone">
                  <i class="pi pi-phone text-gray-500"></i>
                  <span class="meta-value">{{ quoteParameters.client.phone }}</span>
                </div>
                <div class="meta-item" *ngIf="quoteParameters.client._id">
                  <i class="pi pi-id-card text-gray-500"></i>
                  <span class="meta-value client-id">ID: {{ quoteParameters.client._id.slice(-8) }}</span>
                </div>
              </div>
            </div>
          </div>

          <!-- Quote Timeline -->
          <div class="quote-timeline">
            <div class="timeline-header">
              <i class="pi pi-clock text-blue-600"></i>
              <span class="timeline-title">Historial de Cotización</span>
            </div>
            <div class="timeline-items">
              <div class="timeline-item created">
                <div class="timeline-marker created-marker">
                  <i class="pi pi-plus-circle"></i>
                </div>
                <div class="timeline-content">
                  <span class="timeline-label">Creada</span>
                  <span class="timeline-date">{{ formatDate(quoteParameters.createdAt) }}</span>
                </div>
              </div>
              <div class="timeline-item updated" *ngIf="quoteParameters.updatedAt !== quoteParameters.createdAt">
                <div class="timeline-marker updated-marker">
                  <i class="pi pi-pencil"></i>
                </div>
                <div class="timeline-content">
                  <span class="timeline-label">Actualizada</span>
                  <span class="timeline-date">{{ formatDate(quoteParameters.updatedAt) }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Assets Information Card - Enhanced and Double Width -->
      <div class="info-card assets-enhanced-card">
        <div class="card-header">
          <i class="pi pi-box text-blue-600"></i>
          <h3>Información de Activos</h3>
          <div class="header-tags">
            <p-tag [value]="getTotalAssetsCount() + ' activo(s)'" severity="info" class="count-tag"> </p-tag>
            <p-tag *ngIf="hasDefinitiveAssets()" value="Definitivos" severity="success" class="assets-tag"> </p-tag>
            <p-tag *ngIf="!hasDefinitiveAssets()" value="Provisional" severity="warning" class="assets-tag"> </p-tag>
          </div>
        </div>
        <div class="card-content">
          <!-- Plan v4.3 §7 · Tipo de activo que eligió el cliente; un interno lo corrige aquí -->
          <app-asset-type-field
            class="asset-type-row"
            [quotationParametersId]="quoteParameters._id ?? null"
            [assetType]="quoteParameters.assetType ?? null"
            (changed)="quoteParameters.assetType = $event"
          >
          </app-asset-type-field>

          <!-- Provisional Assets View -->
          <div *ngIf="!hasDefinitiveAssets()" class="provisional-assets">
            <div class="provisional-banner">
              <div class="provisional-icon">
                <i class="pi pi-exclamation-triangle text-4xl text-orange-500"></i>
              </div>
              <div class="provisional-info">
                <h4 class="provisional-title">{{ quoteParameters.provitionalAsset || 'Activo no especificado' }}</h4>
                <p class="provisional-subtitle">Información provisional pendiente de confirmar</p>
                <div class="provisional-value-display">
                  <span class="value-label">Valor estimado</span>
                  <span class="value-amount">{{ quoteParameters.provitionalValue | currency: 'MXN' : 'symbol' : '1.2-2' }}</span>
                </div>
              </div>
            </div>
          </div>

          <!-- Definitive Assets View - Horizontal Layout -->
          <div *ngIf="hasDefinitiveAssets()" class="definitive-assets-horizontal">
            <!-- Assets Summary Bar - Horizontal with Better Spacing -->
            <div class="assets-summary-bar-horizontal">
              <div class="summary-stat">
                <i class="pi pi-tags text-blue-600"></i>
                <div class="stat-content">
                  <span class="stat-label">Categorías</span>
                  <span class="stat-value">{{ getAssetsCategorySummary() || 'No especificada' }}</span>
                </div>
              </div>
              <div class="summary-stat">
                <i class="pi pi-calendar text-green-600"></i>
                <div class="stat-content">
                  <span class="stat-label">Registrados</span>
                  <span class="stat-value">{{ formatDate(getDefinitiveAssets()[0]?.createdAt) || 'Fecha no disponible' }}</span>
                </div>
              </div>
            </div>

            <!-- Assets and Financial Layout - Two Column with Better Structure -->
            <div class="assets-financial-container">
              <!-- Left Column: Assets List -->
              <div class="assets-list-section">
                <div class="section-header">
                  <div class="section-title">
                    <i class="pi pi-list text-blue-600"></i>
                    <h4>Activos Incluidos</h4>
                  </div>
                </div>

                <!-- Detailed Assets List - Improved Horizontal Cards -->
                <div *ngIf="hasDetailedAssets()" class="assets-list-container">
                  <div class="asset-card-improved" *ngFor="let asset of getDefinitiveAssets(); let i = index; trackBy: trackByAssetId">
                    <!-- Asset Header with Clear Hierarchy -->
                    <div class="asset-header-section">
                      <div class="asset-identity">
                        <div class="asset-number">{{ i + 1 }}</div>
                        <div class="asset-name-section">
                          <h5 class="asset-name">{{ asset.name }}</h5>
                          <div class="asset-status-badges">
                            <span class="category-badge">{{ asset.category }}</span>
                            <span class="status-badge" [ngClass]="getAssetStatusClass(asset.status)">
                              {{ asset.status || 'Sin estado' }}
                            </span>
                          </div>
                        </div>
                      </div>
                      <div class="asset-value-section">
                        <span class="asset-total-value" *ngIf="asset.acquisition">
                          {{ asset.acquisition.total | currency: 'MXN' : 'symbol' : '1.0-0' }}
                        </span>
                      </div>
                    </div>

                    <!-- Asset Details Grid - Better Organized -->
                    <div class="asset-details-section" *ngIf="asset.brand || asset.assetModel || asset.serie || asset.color">
                      <div class="details-grid">
                        <div class="detail-chip" *ngIf="asset.brand" pTooltip="Marca: {{ asset.brand }}" tooltipPosition="top">
                          <span class="chip-icon">🏷️</span>
                          <span class="chip-text">{{ asset.brand }}</span>
                        </div>
                        <div class="detail-chip" *ngIf="asset.assetModel" pTooltip="Modelo: {{ asset.assetModel }}" tooltipPosition="top">
                          <span class="chip-icon">🔧</span>
                          <span class="chip-text">{{ asset.assetModel }}</span>
                        </div>
                        <div class="detail-chip" *ngIf="asset.serie" pTooltip="Número de Serie: {{ asset.serie }}" tooltipPosition="top">
                          <span class="chip-icon">🔢</span>
                          <span class="chip-text">{{ asset.serie }}</span>
                        </div>
                        <div class="detail-chip" *ngIf="asset.color" pTooltip="Color: {{ asset.color }}" tooltipPosition="top">
                          <span class="chip-icon">🎨</span>
                          <span class="chip-text">{{ asset.color }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Simple Assets List - if no detailed info -->
                <div *ngIf="!hasDetailedAssets()" class="simple-assets-container">
                  <div class="simple-asset-item" *ngFor="let asset of getDefinitiveAssets()">
                    <i class="pi pi-box text-blue-500"></i>
                    <span class="simple-asset-name">{{ asset.name || asset }}</span>
                  </div>
                </div>
              </div>

              <!-- Right Column: Financial Summary -->
              <div>
                <div class="section-header">
                  <div class="section-title">
                    <i class="pi pi-calculator text-green-600"></i>
                    <h4>Resumen Financiero</h4>
                  </div>
                </div>

                <div class="financial-summary-card">
                  <div class="financial-breakdown">
                    <div class="breakdown-row subtotal-row">
                      <span class="breakdown-label">Subtotal</span>
                      <span class="breakdown-value">{{ quoteParameters.assetsValue.amount | currency }}</span>
                    </div>
                    <div class="breakdown-row iva-row">
                      <span class="breakdown-label">IVA</span>
                      <span class="breakdown-value">{{ quoteParameters.assetsValue.iva | currency }}</span>
                    </div>
                    <div class="breakdown-separator"></div>
                    <div class="breakdown-row total-row">
                      <span class="breakdown-label">Total</span>
                      <span class="breakdown-value total-amount">{{ quoteParameters.assetsValue.total | currency }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Financial Configuration Card - Full Width -->
    <div class="info-card wide-card">
      <div class="card-header">
        <i class="pi pi-calculator text-green-600"></i>
        <h3>Configuración Financiera</h3>
      </div>
      <div class="card-content">
        <div class="financial-grid">
          <div class="financial-item">
            <span class="label">Tipo de arrendamiento:</span>
            <p-tag [value]="quoteParameters.leaseType" severity="info" class="lease-type-tag"></p-tag>
          </div>
          <div class="financial-item">
            <span class="label">Anticipo:</span>
            <div class="values-row">
              <span class="value financial-value">{{ quoteParameters.advance | number: '1.2-2' }}%</span>
              <span class="financial-amount">{{ getAdvanceAmount() | currency: 'MXN' : 'symbol' : '1.2-2' }}</span>
            </div>
          </div>
          <div class="financial-item">
            <span class="label">Comisión de apertura:</span>
            <div class="values-row">
              <span class="value financial-value">{{ quoteParameters.openingCommission | number: '1.2-2' }}%</span>
              <span class="financial-amount">{{ getOpeningCommissionAmount() | currency: 'MXN' : 'symbol' : '1.2-2' }}</span>
            </div>
          </div>
          <div class="financial-item">
            <span class="label">Tasa de interés:</span>
            <span class="value financial-value">{{ quoteParameters.interestRate | number: '1.2-2' }}%</span>
          </div>
          <div class="financial-item">
            <span class="label">Rentas anticipadas:</span>
            <span class="value financial-value">{{ quoteParameters.advancedRents }} meses</span>
          </div>
          <div class="financial-item">
            <span class="label">Gastos de ratificación:</span>
            <span class="value financial-value">{{ quoteParameters.ratificationExpenses | currency }}</span>
          </div>
        </div>
      </div>
    </div>

    <!-- Terms and Accessories Row -->
    <div class="cards-grid">
      <!-- Terms Table Card -->
      <div class="info-card">
        <div class="card-header">
          <i class="pi pi-list text-purple-600"></i>
          <h3>Términos Configurados</h3>
          <p-tag [value]="quoteParameters.terms.length + ' término(s)'" severity="info" class="ml-auto"></p-tag>
        </div>
        <div class="card-content">
          <div class="terms-table">
            <div class="table-header">
              <span class="header-cell">Término (meses)</span>
              <span class="header-cell">Valor Residual (%)</span>
            </div>
            <div class="table-body">
              <div class="table-row" *ngFor="let term of quoteParameters.terms">
                <span class="body-cell">{{ term.term }}</span>
                <span class="body-cell">{{ term.residuary | number: '1.2-2' }}%</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Accessories Card -->
      <div class="info-card" *ngIf="getAccessoriesCount() > 0">
        <div class="card-header">
          <i class="pi pi-plus-circle text-cyan-600"></i>
          <h3>Accesorios</h3>
          <p-tag [value]="getAccessoriesCount() + ' accesorio(s)'" severity="info" class="ml-auto"></p-tag>
        </div>
        <div class="card-content">
          <!-- Regular Accessories -->
          <div *ngIf="getRegularAccessories().length > 0" class="accessories-section">
            <h4 class="section-subtitle">Accesorios Regulares</h4>
            <div class="accessories-list">
              <div class="accessory-item" *ngFor="let accessory of getRegularAccessories()">
                <div class="accessory-header">
                  <span class="accessory-name">{{ accessory.name }}</span>
                  <p-tag
                    [value]="accessory.paymentType === 'cash' ? 'Contado' : 'Financiado'"
                    [severity]="accessory.paymentType === 'cash' ? 'success' : 'info'"
                    class="payment-tag"
                  >
                  </p-tag>
                </div>
                <div class="accessory-details">
                  <span class="detail-item">
                    <i class="pi pi-dollar text-green-600"></i>
                    {{ accessory.amount | currency }}
                  </span>
                  <span class="detail-item" *ngIf="accessory.interestRate">
                    <i class="pi pi-percentage text-blue-600"></i>
                    {{ accessory.interestRate | number: '1.2-2' }}%
                  </span>
                </div>
              </div>
            </div>
          </div>

          <!-- Insurance Accessories -->
          <div *ngIf="getInsuranceAccessories().length > 0" class="accessories-section">
            <h4 class="section-subtitle">Seguros</h4>
            <div class="accessories-list">
              <div class="accessory-item insurance-item" *ngFor="let insurance of getInsuranceAccessories()">
                <div class="accessory-header">
                  <span class="accessory-name">{{ insurance.name }}</span>
                  <p-tag
                    [value]="insurance.paymentType === 'cash' ? 'Contado' : 'Financiado'"
                    [severity]="insurance.paymentType === 'cash' ? 'success' : 'info'"
                    class="payment-tag"
                  >
                  </p-tag>
                </div>
                <div class="accessory-details">
                  <span class="detail-item">
                    <i class="pi pi-dollar text-green-600"></i>
                    {{ insurance.amount | currency }}
                  </span>
                  <span class="detail-item" *ngIf="insurance.insuranceDetails?.provider">
                    <i class="pi pi-building text-indigo-600"></i>
                    {{ insurance.insuranceDetails?.provider }}
                  </span>
                </div>
                <div class="insurance-period" *ngIf="insurance.insuranceDetails?.startPeriod && insurance.insuranceDetails?.endPeriod">
                  <i class="pi pi-calendar text-orange-600"></i>
                  <span class="period-text">
                    {{ insurance.insuranceDetails?.startPeriod | date: 'dd/MM/yyyy' }} -
                    {{ insurance.insuranceDetails?.endPeriod | date: 'dd/MM/yyyy' }}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- No Accessories Card -->
      <div class="info-card empty-card" *ngIf="getAccessoriesCount() === 0">
        <div class="card-header">
          <i class="pi pi-plus-circle text-gray-400"></i>
          <h3>Accesorios</h3>
        </div>
        <div class="card-content">
          <div class="empty-state">
            <i class="pi pi-inbox text-6xl text-gray-300"></i>
            <p class="empty-message">No se han configurado accesorios para esta cotización</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- No data message -->
<div *ngIf="!quoteParameters && !loading" class="no-data-container">
  <div class="no-data-card">
    <i class="pi pi-exclamation-triangle text-6xl text-orange-400"></i>
    <h3>Parámetros no encontrados</h3>
    <p>No se encontraron parámetros de cotización con el ID proporcionado</p>
    <button pButton type="button" label="Volver al listado" icon="pi pi-arrow-left" class="p-button-outlined" (click)="goBack()"></button>
  </div>
</div>

<!-- Modal de edición de parámetros -->
<p-dialog
  [(visible)]="showEditModal"
  header="Editar Parámetros de Cotización"
  [style]="{ width: '95vw', height: '90vh' }"
  [modal]="true"
  [closable]="true"
  [draggable]="false"
  [resizable]="false"
  (onHide)="onFormCancel()"
>
  <ng-template pTemplate="content">
    <div class="modal-content-wrapper">
      <app-quote-form></app-quote-form>
    </div>
  </ng-template>

  <ng-template pTemplate="footer">
    <button pButton pRipple label="Cancelar" icon="pi pi-times" class="p-button-text p-button-danger" (click)="onFormCancel()"></button>
    <button
      pButton
      pRipple
      label="Guardar"
      icon="pi pi-check"
      class="p-button-outlined p-button-success"
      (click)="saveForm()"
      [loading]="editingParameters"
      [disabled]="!quoteParametersService.entity.valid"
    ></button>
    <button
      pButton
      pRipple
      label="Calcular"
      icon="fa-solid fa-calculator"
      class="p-button-primary"
      [loading]="editingParameters"
      (click)="getAmounts()"
      [disabled]="!quoteParametersService.entity.valid"
    ></button>
  </ng-template>
</p-dialog>

<p-dialog
  [(visible)]="showPdfOptionsDialog"
  [modal]="true"
  [closable]="false"
  [draggable]="false"
  styleClass="pdf-confirm-dialog"
  header="Opciones de PDF"
>
  <div class="flex align-items-center gap-3">
    <i class="pi pi-file-pdf" style="font-size: 1.5rem"></i>
    <span>¿Deseas incluir el valor residual (opción de compra) en la cotización PDF?</span>
  </div>
  <ng-template pTemplate="footer">
    <div class="flex justify-content-between w-full">
      <button
        pButton
        type="button"
        label="Cancelar"
        icon="pi pi-times"
        class="p-button-outlined p-button-danger"
        (click)="closePdfDialog()"
      ></button>
      <div class="flex gap-2">
        <button
          pButton
          type="button"
          label="No, omitir"
          icon="pi pi-minus-circle"
          class="p-button-outlined"
          (click)="generatePdf(false)"
        ></button>
        <button
          pButton
          type="button"
          label="Sí, incluir"
          icon="pi pi-check-circle"
          class="p-button-primary"
          (click)="generatePdf(true)"
        ></button>
      </div>
    </div>
  </ng-template>
</p-dialog>
